// extracted by mini-css-extract-plugin
export default {"checkout":"CheckoutRoot_checkout__mwna0","container":"CheckoutRoot_container__sqEfq"};